import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";

/**
 * Map services to appropriate ion & custom icons
 */
@Component({
  selector: "app-services-icon",
  templateUrl: "./services-icon.component.html",
  styleUrls: ["./services-icon.component.scss"],
})
export class ServicesIconComponent implements OnInit {
  iconMatch: string;

  @Input() icon: string;
  @ViewChild("content", { static: true }) content: TemplateRef<{}>;

  constructor(private readonly viewContainer: ViewContainerRef) {}

  ngOnInit() {
    if (this.icon) {
      this.iconMatch = this.icon;
    } else {
      this.iconMatch = "chevron-forward-circle-outline";
    }

    this.viewContainer.createEmbeddedView(this.content);
  }
}
